import styled from "styled-components"
import { up } from "styled-breakpoints"
import Link from "next/link"
import colors from "@constants/colors"
import measurements from "@constants/measurements"
import { bodyBold } from "@constants//typography"

interface StyledLinkProps {
  $buttonColor?: string
  $buttonTextColor?: string
}

export const StyledLink = styled.a<StyledLinkProps>`
  ${bodyBold}
  align-items: center;
  justify-content: center;
  display: flex;
  outline: none;
  width: 100%;
  height: ${measurements.LINK_BUTTON_HEIGHT};
  padding: 0 24px;
  border: none;
  border-radius: 2px;
  background-color: ${({ $buttonColor }) =>
    $buttonColor ? `#${$buttonColor}` : colors.snow};
  cursor: pointer;
  text-align: center;
  color: ${({ $buttonTextColor }) =>
    $buttonTextColor ? `#${$buttonTextColor}` : colors.obsidian};

  ${up("laptop")} {
    width: initial;

    &:hover {
      cursor: pointer;
    }
  }
`

export interface LinkButtonProps {
  href: string
  children: React.ReactNode
  onClick?: () => void
  buttonColor?: string
  buttonTextColor?: string
}

const LinkButton: React.FC<LinkButtonProps> = ({
  href,
  children,
  onClick,
  buttonColor,
  buttonTextColor,
  ...rest
}) => {
  return (
    <Link href={href} passHref onClick={onClick}>
      <StyledLink
        {...rest}
        $buttonColor={buttonColor}
        $buttonTextColor={buttonTextColor}
      >
        {children}
      </StyledLink>
    </Link>
  )
}

export default LinkButton
